

var list = $( '#services img.tile-img-ser' ).toArray(),
	caption = $( '#services .tile-servizi .caption' ).toArray(),
	desc = $( '#services .tile-servizi .description' ).toArray(),
	container = $('.recive'),
	listLength = list.length,
	slideEl = '',
	slideCount = null,
	i = 0;




// Onload  events

	$( document ).ready(function() {
		var winScrolled = document.body.scrollTop || document.documentElement.scrollTop;
		counter(),
		getPageImages(),
		changeMenu(winScrolled)
		changeFooter(winScrolled)
		mouseCursor()
		$('.recive').slick({
			nextArrow: $('.next'),
			prevArrow: $('.prev'),
			dots: false,
			infinite: true,
			speed: 300,
			slidesToShow: 1,
			draggable:true,
		});
	});


//--- scroll event

	window.onscroll = function() { 

		var winScrolled = document.body.scrollTop || document.documentElement.scrollTop,
			scrollBottom = $(window).scrollTop() + $(window).height(),
			docHeight = $(document).height();
   
		if ( scrollBottom == docHeight) {
			$('footer').addClass('grey-footer')
		} else {
			$('footer').removeClass('grey-footer')
		}

		changeMenu(winScrolled), 
		changeFooter(winScrolled),
		menu(),
		parallax()
		//bigOnScreen()
		
	};


//get content for modal

	function getPageImages() {
		for (i = 0; i < listLength; i++) {
			var el =  list[i].outerHTML,
				cap = caption[i].outerHTML,
				dsc = desc[i].outerHTML;
				slideEl += '<div class="slide"><div class="card-service">' + el + '<div class="text">' +cap + dsc + '</div></div></div>';
			container.html( slideEl );
		}
	}



//open clicked image

	$('#services .tile-servizi').click( function() {
		var src = $(this).find('img').attr('src'),
			index = null;

		list.forEach(function(imgCompare,i){
			if ($(imgCompare).attr('src') === src){
				index = i
			}
		})
		$('.modal').removeClass('modal-close');
		$('.recive').slick('slickGoTo',index);
		$('body').addClass('hidden');
		// $('.card-service img').addClass('parallax');
	});

//close modal

	$('.close').click(function() {
		$('.modal').addClass('modal-close');
		$('body').removeClass('hidden');
	});

//slides counter

	function counter() {
		$('.recive').on('init', function(event, slick){
			slideCount = slick.slideCount;
			setSlideCount();
			setCurrentSlideNumber(slick.currentSlide);
		});

		$('.recive').on('beforeChange', function(event, slick, currentSlide, nextSlide){
			setCurrentSlideNumber(nextSlide);
		});

		function setSlideCount() {
			$('.total').text(slideCount);
		}

		function setCurrentSlideNumber(currentSlide) {
			$('.current').text(currentSlide + 1);
		}  
	}




// menu on scroll

	function changeMenu(scroll) {
		if(scroll >= 1){
			$('header').addClass('tiny-header');
		}
		else {
			$('header').removeClass('tiny-header');
		}
	}

// footer on scroll

	function changeFooter(scroll) {
		if( scroll > 100  ||  $('body').hasClass('template-contatti') ){
			$('footer').addClass('show-footer');
		}
		else {
			$('footer').removeClass('show-footer');
		}

	}




// effetto on scroll

	function parallax() {
		if (document.querySelector(".parallax")){

			var winScroll = document.body.scrollTop || document.documentElement.scrollTop,
				elHeight = document.querySelector(".parallax").scrollHeight,
				scrolled = winScroll / elHeight;

			document.querySelector(".parallax").style.objectPosition = "50% " + (scrolled * 150) + "%";
		}
		//document.querySelector(".hero-home").style.opacity = 1 - (scrolled * 1.25);
	}

// show tiny menu on specific pages

	window.onload = function() { menu() };

	function menu() {
		if( $('body').is('.template-lavori, .template-contatti, .template-premiazioni, .blog, .post-template-default') ){
			$('body .header').addClass('tiny-header');
		}
	}

// menu mobile

	$('.hamburgher').click(function() {
		$('.mobile-menu').addClass('menu-open');
		$('body').addClass('hidden');
	});

	$('.mobile-menu svg').click(function() {
		$('.mobile-menu').removeClass('menu-open');
		$('body').removeClass('hidden');
	});

	$('.mobile-menu .menu-item-has-children').click(function() {
		$('.mobile-menu .sub-menu').toggleClass('sub-menu-open');
		$('.menu-item-has-children a').toggleClass('more');
	});

// custom cursor move

	function mouseCursor() {
		$(window).mousemove(function(e) {
			$('.cursor').eq(0).css({
				left: e.pageX,
				top: e.pageY - $(window).scrollTop(),
			});
			setTimeout( function() {
				$('.cursor').eq(1).css({
					left: e.pageX,
					top: e.pageY - $(window).scrollTop(),
				});
			}, 75);
		})
	}

// custom cursor on ancor hover

	$('a, button, .tile-servizi, .anchor').on({
		mouseenter: function() { 
			$('.cursor').addClass('big'); 
		},
		mouseleave: function() { 
			$('.cursor').removeClass('big'); 
		},
	});


// custom cursor on select language hover

	$('header a').on({
		mouseenter: function() { 
			$('.cursor').addClass('lang-big'); 
		},
		mouseleave: function() { 
			$('.cursor').removeClass('lang-big'); 
		},
	});

	// $('.desktop-menu ul.nav li.menu-item-has-children').hover( function() {
	//  $('ul.nav').toggleClass('sub-open');
	// })


// menu lavori

	$('.desktop-menu ul.nav li.menu-item-has-children, .hero-go-to-works a').click( function() {
		$('.menu-brands-container').addClass('open-brand');
		$('body').addClass('open-works');
		setTimeout( function() {
			$('.menu-brand-block').addClass('delay-block');
		}, 1500);
	})

	$('.menu-brands-container svg').click( function() {
		$('.menu-brands-container').removeClass('open-brand');
		$('body').removeClass('open-works');
		$('.menu-brand-block').removeClass('delay-block');
	})
	

// awards open

	$('.square').click( function() {
		$('.square').addClass('disappear');
		$('body').addClass('hidden bg-black');
		var att = $(this).attr('data-event'),
			tabs = $('.tab-awards').toArray();

		tabs.forEach( function(attrCompare,i){
			if ($(attrCompare).attr('id') === att) {
				console.log(tabs[i])
				tabs[i].classList.add('show');
				$('.additional-awards').addClass('display-block-none');
			}
		})
	});

	$('header, .back').click(function() {
		if( $('.square').hasClass('disappear')) {
			$('.square').removeClass('disappear');
			$('.tab-awards').removeClass('show')
			$('body').removeClass('hidden bg-black');
			$('.additional-awards').removeClass('display-block-none');
		}
	});




// function bigOnScreen() {

// 	var bigEl = document.querySelector("#bigg");

// 	var observer = new IntersectionObserver( function(entries) {
// 		//entries.forEach( function(){ console.log(i);});
	
// 		if( entries[0].isIntersecting === true){
			
// 			let top = entries[0].intersectionRect.top;

// 			document.querySelector("#bigg").style.transform = 'translateX(' + (top / 1.5) + 'px)';
			
// 		}	

// 	});

// 	observer.observe(bigEl);

// }

















// WEBPACK FOOTER //
// ./scripts/routes/modal.js